import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-tag/jb-tag.css.ts
var jb_tag_css_default = i`:host{cursor:pointer;display:block}div{align-items:center;border:solid 2px #fff;display:flex;height:50px;justify-content:center;outline:none;padding:14px;transition:margin .7s,width .7s,height .7s;width:50px;z-index:2}svg{height:18px;outline:none;transition:transform .7s;width:18px}div.large{height:70px;margin:30px;width:70px}div.large svg{transform:scale(1.3333)}@media(forced-colors: active){svg{fill:CanvasText}}`;

export {
  jb_tag_css_default
};
